module.exports = __webpack_public_path__ + "static/media/login.d8dcc7da.svg";